const forceProd = false

const isDev = (window.location.hostname.includes('develop') || window.location.hostname.includes('andromeda')) && !forceProd
const isBeta = window.location.hostname.includes('beta') && !forceProd
const isProd = !isDev && !isBeta && (window.location.hostname.includes('orionx.') || forceProd)

export default () => {
  if (isDev) return 'dev'
  if (isBeta) return 'beta'
  if (isProd) return 'prod'

  return 'local'
}



// WEBPACK FOOTER //
// ./src/App/Root/getEnv.js